<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-8 col-12 mb-2">
                <div class="row breadcrumbs-top">
                    <div class="col-12">
                        <h2 class="content-header-title float-left mb-0">{{trans('school.school')}}
                        </h2>
                        <div class="breadcrumb-wrapper col-12">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/home">
                                        {{ trans('general.home') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item">
                                    <router-link to="/schools">
                                        {{ trans('school.school') }}
                                    </router-link>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ trans('school.create_school') }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-header-right text-md-right col-md-4 col-12 d-md-block d-none">
                <div class="form-group breadcrum-right">
                    <button class="btn btn-primary btn-sm pull-right" @click="$router.push('/schools')"><i class="feather icon-list"></i> {{trans('school.school_list')}}</button>

                    <button class="btn btn-primary btn-sm pull-right mr-2" @click="$router.push('/schools/import')"><i class="feather icon-file-text"></i> {{trans('school.upload_school')}}</button>
                    
                </div>
            </div>

        </div>

        <div class="content-body">
            <div class="card">
                <div class="card-header">
                    <h4 class="card-title">{{trans('school.create_school')}}</h4>
                </div>

                <div class="card-content">
                    <div class="card-body">
                        <school-form :id="id"></school-form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import schoolForm from './form';

    export default {
        components : { schoolForm },
        data() {
            return {
                id:this.$route.params.id
            }
        },
        mounted(){
            if(!helper.hasPermission('create-schools')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('school')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

        }
    }
</script>
